module.exports = __webpack_public_path__ + "img/Dymaxion-clock@2x.5c862906.png";